module.exports = __webpack_public_path__ + "static/img/gift-box-img.a90fc86.png";